import React, { ReactNode } from 'react';

import { styled } from 'styled-components';

import Tag, { TagProps } from 'components/Tags/Tag';

const TagsList = styled.div`
  display: flex;
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export interface TagsProps {
  tags: TagProps[];
  label?: ReactNode;
}

const Tags = ({ tags, label }: TagsProps) => {
  return (
    <div>
      {label}
      <TagsList>
        {tags.map((tag, i) => (
          <Tag
            key={i}
            label={tag.label}
            color={tag.color}
            url={tag.url}
            onClick={tag.onClick}
            noHover={tag.noHover}
            inverse={tag.inverse}
            borderColor={tag.borderColor}
            textHoverColor={tag.textHoverColor}
          />
        ))}
      </TagsList>
    </div>
  );
};

export default Tags;
